module.exports = __webpack_public_path__ + "static/media/qr_code_mp.e7e86c55.png";